import { Link } from "react-router-dom";
import { ArrowUpRight, Ticket } from "lucide-react";
import { formatEventDate, formatTime, isPast } from "@/lib/api";
import { EVENT_TYPE_LABEL } from "@/lib/eventTypes";

export const EventCard = ({ event, index = 0 }) => {
  const past = isPast(event.date);
  return (
    <article className="group reveal" style={{ animationDelay: `${index * 80}ms` }} data-testid={`event-card-${event.id}`}>
      <Link to={`/agenda/${event.slug}`} data-testid={`event-image-link-${event.id}`} className="block overflow-hidden bg-[hsl(var(--surface))] aspect-[5/3] relative">
        {(
          <img
            src={event.image || "/brand/fallback.jpg"}
            alt={event.title}
            loading="lazy"
            className={`w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 ${past ? "grayscale-[60%]" : ""}`}
          />
        )}
        {past && (
          <span className="absolute top-4 left-4 bg-black text-white text-[10px] uppercase tracking-[0.2em] font-bold px-3 py-1.5">Passé</span>
        )}
        {EVENT_TYPE_LABEL[event.types?.[0]] && (
          <span className="absolute top-4 right-4 bg-primary text-white text-[10px] uppercase tracking-[0.2em] font-bold px-3 py-1.5" data-testid={`event-type-${event.id}`}>
            {(event.types || []).map((t) => EVENT_TYPE_LABEL[t]).filter(Boolean).join(" · ")}
          </span>
        )}
      </Link>
      <div className="pt-5">
        <p className="text-sm font-bold text-primary" data-testid={`event-date-${event.id}`}>
          {formatEventDate(event.date)} · {formatTime(event.date)}{event.venue && <> &nbsp;-&nbsp; {event.venue}</>}
        </p>
        <h3 className="font-display uppercase text-3xl lg:text-4xl leading-[0.95] mt-2 text-white">{event.title}</h3>
        <p className="text-zinc-400 text-sm mt-2 break-words">{event.address}</p>
        <div className="flex flex-wrap gap-3 mt-5">
          {event.ticket_url && !past && (
            <a
              href={event.ticket_url}
              target="_blank"
              rel="noreferrer"
              data-testid={`event-ticket-${event.id}`}
              className="inline-flex items-center gap-2 bg-primary text-white uppercase text-xs font-bold tracking-[0.2em] px-4 py-3 hover:bg-white hover:text-black transition-colors duration-200"
            >
              <Ticket className="w-4 h-4" /> Billetterie
            </a>
          )}
          <Link
            to={`/agenda/${event.slug}`}
            data-testid={`event-info-${event.id}`}
            className="inline-flex items-center gap-2 border border-white/20 text-white uppercase text-xs font-bold tracking-[0.2em] px-4 py-3 hover:border-white transition-colors duration-200"
          >
            Plus d'infos <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </article>
  );
};
